import { createFileRoute } from '@tanstack/react-router'

import { LoadboardsPage } from '#/modules/loadboards/loadboards-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/loadboards')({
  component: LoadboardsPage,
  validateSearch: validateListSearch,
})
